import { z } from 'zod'
import { plainTextLength } from './plainTextLength'

const nameField = z.string().superRefine((val, ctx) => {
  const len = plainTextLength(val ?? '')
  if (len === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Instrument name is required',
    })
    return
  }
  if (len < 3) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Instrument name must be at least 3 characters',
    })
    return
  }
  if (len > 100) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Instrument name cannot exceed 100 characters',
    })
  }
})

export const instrumentInfoSchema = z.object({
  name: nameField,
  description: z.string().superRefine((val, ctx) => {
    if (!val || plainTextLength(val) === 0) return
    const len = plainTextLength(val)
    if (len > 0 && len < 10) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Description must be at least 10 characters if provided',
      })
      return
    }
    if (len > 500) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Description cannot exceed 500 characters',
      })
    }
  }),
})

export type InstrumentInfoFormData = z.infer<typeof instrumentInfoSchema>
